import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';

async function getRaioxAlunosDetail(params): Promise<any> {
  const api = await getApi();
  const { data } = await api.get<any>(`/raiox/alunos/${params.id}`, {});
  return data;
}

type QueryFnType = typeof getRaioxAlunosDetail;

function useRaioxAlunosDetail(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-raiox-alunos-detail', params],
    queryFn: () =>  getRaioxAlunosDetail(params),
  });
}

export { useRaioxAlunosDetail };
